import { __ } from "@jti/fe-common";
const CATEGORIES = ["product_types", "services"];
export const getFiltersBaseOnFlotiqResponse = (stores, filtersTranslations) => {
    const translateFilters = (key) => {
        return filtersTranslations?.find(({ filterKey }) => filterKey === key)?.translatedFilterKey || key;
    };
    const filters = stores.reduce((acc, store) => {
        CATEGORIES.forEach((category) => {
            store[category]?.forEach((item) => {
                const filter = acc.find((filter) => filter.key === category);
                if (!filter?.filters.find((filter) => filter.key === item.key)) {
                    const name = translateFilters(item.key);
                    filter?.filters.push({
                        name: name,
                        key: item.key,
                        value: item.key,
                        label: name,
                    });
                }
            });
        });
        return acc;
    }, [
        {
            name: __("storelocator.filters.category.product_types"),
            key: "product_types",
            filters: [],
        },
        {
            name: __("storelocator.filters.category.services"),
            key: "services",
            filters: [],
        },
    ]);
    return filters;
};
//# sourceMappingURL=getFiltersBaseOnFlotiqResponse.js.map